import { ACCEPT_PAYMENTS } from '@/common/permissionConstants';
import { useFeatureFlags } from '@/composables/useFeatureFlags';

const featureFlagGuard = () => {
    const { isEnabled } = useFeatureFlags();
    if (!isEnabled('fortis-payments')) return { name: 'home' };
};

export default [
    {
        path: 'payments',
        name: 'payments',
        meta: { label: 'Payments', hasPermission: ACCEPT_PAYMENTS },
        component: () => import('@/views/PaymentsPage.vue'),
        beforeEnter: featureFlagGuard,
    },
];
